// src/components/Header.tsx
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authService } from '../api/authService';

const Header: React.FC = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        authService.logout();
        navigate("/login");
    };

    // ✅ Compute role from localStorage once
    const role = localStorage.getItem("role");
    const homePath =
        role === "ADMIN"
            ? "/admin-user"
            : role === "ORGANIZATION"
                ? "/org"
                : "/login";

    return (
        <header className="navbar navbar-expand-lg navbar-light bg-white shadow-sm border-bottom">
            <div className="container-fluid">
                {/* ✅ Now logo redirects correctly based on role */}
                <Link className="navbar-brand fw-bold fs-4 text-primary" to={homePath}>
                    <img
                        className='me-2'
                        src="/raiserSyncLogo.png"
                        alt="RaiserSync Logo"
                        style={{ height: "32px", width: "32px", objectFit: "contain" }}
                    />
                    <span>RaiserSync Admin</span>

                </Link>

                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav me-auto">
                        {/* <li className="nav-item">
                            <Link
                                className={`nav-link ${location.pathname === '/queue-monitoring' ? 'active fw-semibold' : ''}`}
                                to="/queue-monitoring"
                            >
                                <Activity size={16} className="me-1" />
                                Queue Monitoring
                            </Link>
                        </li> */}
                        {/* <li className="nav-item">
                            <Link
                                className={`nav-link ${location.pathname === '/queue-management' ? 'active fw-semibold' : ''}`}
                                to="/queue-management"
                            >
                                <ServerCog size={16} className="me-1" />
                                Queue Management
                            </Link>
                        </li> */}
                    </ul>

                    <div className="d-flex align-items-center">
                        <div className="d-flex align-items-center me-3">
                            <div
                                className="bg-success rounded-circle me-2"
                                style={{ width: '8px', height: '8px' }}
                            ></div>
                            <small className="text-muted">System Online</small>
                        </div>
                    </div>

                    <button
                        onClick={handleLogout}
                        className="btn btn-outline-danger btn-sm"
                    >
                        Logout
                    </button>
                </div>
            </div>
        </header>
    );
};

export default Header;
